export const INVOICES_DOMAIN = 'invoices';
export const INVOICES_DOMAIN_URL = `/${INVOICES_DOMAIN}/*`;

export const INVOICES_PATHS = {
  details: '/details',
  paymentProcessing: '/payment-processing',
  billingHistory: '/billing-history',
};

export const INVOICES_PAGE_TITLES = {
  details: 'Invoice Details',
  paymentProcessing: 'Payment Processing',
};
